import React from 'react';

import { getEnv } from '@/app/conf/env';
import { FacebookIcon, InstagramIcon, XTwitterIcon } from '@/icons/fa/brands';
import { EnvelopeIcon, PhoneIcon } from '@/icons/fa/solid';

function Footer() {
  return (
    <footer className="h-40 w-full flex flex-col justify-center items-center font-semibold bg-charcoal-700 text-neutral-400 py-2">
      <div className="text-sm text-center">
        Copyright © 2019-{new Date().getFullYear()} Talquin Electric Cooperative. All Rights Reserved.
      </div>
      <div className="mb-3 text-xs text-center">
        Version {getEnv().APP_VERSION}
      </div>
      <div className="my-2 text-center h-8">
        <SocialLink ariaLabel="Facebook" href="https://facebook.com/TalquinElectricCoop" target="_blank">
          <FacebookIcon className="size-6" />
        </SocialLink>
        <SocialLink ariaLabel="Instagram" href="https://instagram.com/tectwwi" target="_blank">
          <InstagramIcon className="size-6" />
        </SocialLink>
        <SocialLink ariaLabel="X" href="https://x.com/tectwwi" target="_blank">
          <XTwitterIcon className="size-6" />
        </SocialLink>
        <SocialLink
          ariaLabel="Email"
          href="https://www.talquinelectric.com/about-us/contact-us/"
          target="_blank"
        >
          <EnvelopeIcon className="size-6" />
        </SocialLink>
        <SocialLink ariaLabel="Phone" href="tel:8508936853">
          <PhoneIcon className="size-6" />
        </SocialLink>
      </div>
      <div className="text-sm text-center mt-2">
        <a className="text-neutral-400 hover:text-white" href="https://www.talquinelectric.com/privacy-policy/">Privacy Policy</a>
      </div>
    </footer>
  );
}

type SocialLinkProps = {
  ariaLabel: string;
  href: string;
  target?: string;
  children: React.ReactNode;
};

function SocialLink({ ariaLabel, href, target, children }: SocialLinkProps) {
  return (
    <a
      className="inline-block w-15 text-neutral-400 hover:text-white"
      href={href}
      aria-label={ariaLabel}
      {...(target ? { target: target } : {})}
    >
      {children}
    </a>
  );
}

export default Footer;
